module.exports = __webpack_public_path__ + "static/media/headshot_square.a4dd4179.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/headshot_square.jpg
// module id = 36
// module chunks = 0